var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleQuarter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "circle_quarter"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 9",
    cx: 8,
    cy: 8,
    r: 7.5,
    stroke: "black",
    strokeOpacity: 0.87
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 10"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_4138_8320",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 -3.49691e-07C9.05057 -3.95613e-07 10.0909 0.206926 11.0615 0.608963C12.0321 1.011 12.914 1.60028 13.6569 2.34315C14.3997 3.08601 14.989 3.96793 15.391 4.93853C15.7931 5.90914 16 6.94942 16 8L8 8L8 -3.49691e-07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8 -3.49691e-07C9.05057 -3.95613e-07 10.0909 0.206926 11.0615 0.608963C12.0321 1.011 12.914 1.60028 13.6569 2.34315C14.3997 3.08601 14.989 3.96793 15.391 4.93853C15.7931 5.90914 16 6.94942 16 8L8 8L8 -3.49691e-07Z",
    fill: "black",
    fillOpacity: 0.87,
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 2,
    mask: "url(#path-2-inside-1_4138_8320)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleQuarter);
export default __webpack_public_path__ + "static/media/circle_quarter.1662e3623ad38fd452ba1da5015095b6.svg";
export { ForwardRef as ReactComponent };